export default __webpack_public_path__ + "static/media/arrow_down.fe6b3dbb.svg";